import type { StationBrand, StationBrandConfig } from '@centric-os/types';
import type { AxiosResponse } from 'axios';
import { defineStore, type StateTree } from 'pinia';

interface State extends StateTree {
  stations: StationBrand[];
}

export function useSalesChannelStore(storeId = 'salesChannel') {
  const store = defineStore(storeId, {
    state: (): State => ({
      stations: [],
    }),
    actions: {
      async updateSalesChannel(payload: StationBrandConfig) {
        if (payload) {
          await this.cdlApi.patch<
            StationBrandConfig,
            AxiosResponse<StationBrandConfig, any>,
            Partial<StationBrandConfig>
          >(`/location/brand/bulk`, {
            ...payload,
          });
        } else {
          return Promise.reject(new Error('no payload selected'));
        }
      },
      async updateAllSalesChannels(payload: StationBrandConfig) {
        const chunks = [];

        for (let i = 0; i < payload.brands.length; i += 50) {
          chunks.push(payload.brands.slice(i, i + 50));
        }

        const updatePromises = chunks.map((chunk) => {
          const payload: StationBrandConfig = {
            brands: chunk,
          };
          return this.updateSalesChannel(payload);
        });
        await Promise.all(updatePromises);
      },
    },
    getters: {},
    pagination: false,
  });
  return store();
}
